// extracted by mini-css-extract-plugin
module.exports = {"carouselTitle":"_283FK2e82vMqvHqltwAsKM"};